import { EMAIL_REGEX, PHONE_REGEX, STRONG_PASSWORD_REGEX } from "../Constant/Regex";

export const AccountValidationScheema = (json, isEditMode) => {

    console.log("json",json);
    



    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

        if (json?.accountName === undefined || json?.accountName === '') {

            Object.assign(errorJson, { accountName: "Full name cannot be empty *" });
        }
             if (json?.status === undefined || json?.status === '') {

            Object.assign(errorJson, { status: "Slection of status id. required *" });
        }


        resolve(errorJson);
    })
    return MyPromise;
}

